import { render, staticRenderFns } from "./PayeeInfoSetupView.vue?vue&type=template&id=047eb5e2&scoped=true&"
import script from "./PayeeInfoSetupView.vue?vue&type=script&lang=ts&"
export * from "./PayeeInfoSetupView.vue?vue&type=script&lang=ts&"
import style0 from "./PayeeInfoSetupView.vue?vue&type=style&index=0&id=047eb5e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047eb5e2",
  null
  
)

export default component.exports